import {FC} from 'react'
import {Outlet} from "react-router-dom"
import Head from './components/Head'
import Top from './components/Top'
import Footer from './components/Footer'
import style from './style.module.less'

const BaseLayout: FC = () => {
    return (
        <div>
            <Head/>
            <Top/>
            <div className={style.container}>
                <Outlet/>
            </div>
            <Footer/>
        </div>
    )
}

export default BaseLayout
